import React, { Component } from 'react'
import { connect } from 'react-redux'
class Spinner extends Component {
    render() {
        const { size, color, className, companyColor } = this.props;
        return (
            <svg className={className} style={{ width: size || "12px", height: size || "12px" }} version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 100">
                <path fill={color || companyColor || "#3BD4AE" } d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                    <animateTransform
                        attributeName="transform"
                        attributeType="XML"
                        type="rotate"
                        dur="1s"
                        from="0 50 50"
                        to="360 50 50"
                        repeatCount="indefinite" />
                </path>
            </svg>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        companyColor: state.company.styles_json.styles.color_primary
    };
};

export default connect(mapStateToProps)(Spinner)


// WEBPACK FOOTER //
// ./src/components/Spinner.js